module.exports = __webpack_public_path__ + "img/a-bottom.b4beb2ac.png";